<div
    [hidden]="!isVisible"
    [ngClass]="{'animate-slide-in-up': isVisible, 'animate-slide-out-down': hide, 'bg-success': toastData?.type === 'success', 'bg-featured': toastData?.type === 'error'}"
    class="w-full text-white p-5 fixed bottom-0 right-0 transform transition-transform z-50"
>
    <p class="text-sm font-semibold text-center" [innerHTML]="toastData?.text"></p>
</div>
